var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6294 9.66663L14.4998 12.7962L11.3703 9.66663L9.6665 11.3704L12.7961 14.5L9.6665 17.6295L11.3703 19.3333L14.4998 16.2037L17.6294 19.3333L19.3332 17.6295L16.2036 14.5L19.3332 11.3704L17.6294 9.66663ZM14.4998 2.41663C7.81775 2.41663 2.4165 7.81788 2.4165 14.5C2.4165 21.182 7.81775 26.5833 14.4998 26.5833C21.1819 26.5833 26.5832 21.182 26.5832 14.5C26.5832 7.81788 21.1819 2.41663 14.4998 2.41663ZM14.4998 24.1666C9.17109 24.1666 4.83317 19.8287 4.83317 14.5C4.83317 9.17121 9.17109 4.83329 14.4998 4.83329C19.8286 4.83329 24.1665 9.17121 24.1665 14.5C24.1665 19.8287 19.8286 24.1666 14.4998 24.1666Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/IconClose.33149808.svg";
export { ForwardRef as ReactComponent };